export default "__VITE_ASSET__CbeK6_FN__"